// Katman (layers) listesi — z-sıra üstten alta. Tıkla-seç, kilit/göz toggle, sürükle-sırala.
import { useState } from 'react';
import { elementIcon, elementDisplayName } from './elementUtils';

export function LayersPanel({ elements, selIds, onSelect, onToggleLock, onToggleHidden, onReorder }) {
  const [dragId, setDragId] = useState(null);
  const [overId, setOverId] = useState(null);
  // Üstte görünen = dizinin sonu (en yüksek z).
  const ordered = [...elements].reverse();

  if (!elements.length) {
    return <div style={{ padding: 16, color: 'var(--text-secondary)', fontSize: 12.5 }}>Henüz öğe yok. Soldaki “Öğeler” sekmesinden ekleyin.</div>;
  }

  return (
    <div style={{ padding: '6px 8px' }}>
      {ordered.map((el) => {
        const selected = selIds.includes(el.id);
        const isOver = overId === el.id && dragId && dragId !== el.id;
        return (
          <div
            key={el.id}
            draggable
            onDragStart={() => setDragId(el.id)}
            onDragOver={(e) => { e.preventDefault(); setOverId(el.id); }}
            onDragLeave={() => setOverId((p) => (p === el.id ? null : p))}
            onDrop={(e) => { e.preventDefault(); if (dragId && dragId !== el.id) onReorder(dragId, el.id); setDragId(null); setOverId(null); }}
            onDragEnd={() => { setDragId(null); setOverId(null); }}
            onMouseDown={(e) => onSelect(el.id, e.shiftKey || e.ctrlKey || e.metaKey)}
            style={{
              display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', marginBottom: 3,
              borderRadius: 9, cursor: 'grab', fontSize: 12.5,
              background: selected ? 'var(--accent-soft)' : 'transparent',
              border: isOver ? '1px dashed var(--accent)' : '1px solid transparent',
              color: el.hidden ? 'var(--text-secondary)' : 'var(--text-primary)',
              opacity: el.hidden ? 0.6 : 1,
            }}
          >
            <span style={{ width: 18, textAlign: 'center', flexShrink: 0 }}>{elementIcon(el.type)}</span>
            <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: selected ? 700 : 500 }}>{elementDisplayName(el)}</span>
            <button
              type="button" title={el.hidden ? 'Göster' : 'Gizle'}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => { e.stopPropagation(); onToggleHidden(el.id); }}
              style={iconToggle}
            >{el.hidden ? '🚫' : '👁'}</button>
            <button
              type="button" title={el.locked ? 'Kilidi aç' : 'Kilitle'}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => { e.stopPropagation(); onToggleLock(el.id); }}
              style={iconToggle}
            >{el.locked ? '🔒' : '🔓'}</button>
          </div>
        );
      })}
    </div>
  );
}

const iconToggle = { border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 13, padding: 2, lineHeight: 1, flexShrink: 0, opacity: 0.8 };
